@import "../../../../../../styles/mixins";
@import "../../../../../../styles/variables";
$desktop: map-get($breakpoints, desktop);

.private__container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  & .document__container {
    margin: 0;
  }
}

.private__tile {
  display: flex;
  flex-wrap: nowrap;
  margin: 0 0 20px 0;
  a {
    text-decoration: none;
    &:hover {
      .result-card__title-link {
        text-decoration: underline;
      }
    }
  }

  h3 {
    font-size: 18px;
  }
  @media (max-width: $uiaas-tablet) {
    @include shadow-small;
    padding: 20px;
    margin: 0;
    margin-bottom: 20px;

    &:hover {
      @include shadow-medium;
    }
    .result-card__title {
      word-break: break-word;
    }
  }
  @media (min-width: $uiaas-tablet) {
    // display: flex;
  }

  .private-item {
    flex: 1 0 48%;
    word-wrap: break-word;
    width: 50%;
  }

  .private__container {
    @media (min-width: $desktop) {
      flex-wrap: nowrap;
    }
  }
}

.private__divider {
  margin-top: 24px;
  margin-bottom: 14px;
}

.private__title {
  color: $uiass-link-color;
  line-height: 30px;
  font-weight: 400;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.private__label-container {
  padding-top: 12px;
  display: block;
  min-height: 16px;
}

.private__label-panel {
  line-height: 22px;
  font-size: 16px;
  font-weight: 400;
  text-decoration: none;
  color: $svs-se-dark-grey;
  margin-top: 4px;
  @media (min-width: $uiaas-tablet) {
    line-height: 20px;
    font-size: 14px;
  }
}

.private__category {
  color: var(--qds-theme-signature-color-default, #008a16);
}

.thumbnail-section {
  margin-right: 0;
  margin-bottom: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
  @media (min-width: $uiaas-tablet) {
    display: block;
    margin-bottom: 0;
    margin-right: 20px;
    width: 100px;
    height: 100px;
  }
}

.private-card-description {
  margin-top: 5px;
  max-width: 320px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
}

@include label-list;
